export enum StudentAccountType {
    OFFICIAL_ACCOUNTS = "official_accounts",
    TRIAL_PERIOD = "trial",
}
